import React from 'react';
import Box from './Box';

var Card = function Card(props) {
  return React.createElement(Box, props);
};

Card.defaultProps = {
  boxShadow: 80,
  bg: 'background',
  border: 1,
  borderStyle: 'solid',
  borderRadius: 'medium',
  borderColor: 'transparent',
  p: 3,
  textAlign: 'left'
};
export default Card;